module.exports = __webpack_public_path__ + "img/icon-package-plan-type-light.bf0195d.svg";